// Simple component that renders a <Navigate> replace redirect.
// Lets us declare 301-style client redirects for renamed routes.
import { Navigate, useLocation } from "react-router-dom";

export default function Redirect({ to }) {
  const { search } = useLocation();
  return <Navigate to={`${to}${search || ""}`} replace />;
}
